export default __webpack_public_path__ + "static/media/gyalog-felirat.538856cd.png";